import { handleActions } from 'redux-actions';
import { SiteHeaderState } from './types';
import {
  openUserDropdown,
  closeUserDropdown,
  openNotificationsDropdown,
  closeNotificationsDropdown,
  toggleSubmitMenu,
  openSearchModal,
  closeSearchModal,
  toggleSearchModal,
  siteHeaderSearchButtonClicked,
  toggleBurgerMenuRequested,
  userLogoutButtonClicked,
  toggleFeedbackPage,
  openDamzDropdown,
  closeDamzDropdown,
} from './actions';
import { reduxKey } from './constants';

export const initialState: SiteHeaderState = {
  isSearchModalShown: false,
  isUserDropdownOpen: false,
  isBurgerMenuOpen: false,
  isNotificationsDropdownOpen: false,
  isSubmitMenuOpen: false,
  isLoggingOut: false,
  isDamzDropdownOpen: false,
};

const actionHandlers = handleActions<SiteHeaderState, any>(
  {
    [openSearchModal.toString()]: state => ({
      ...state,
      isSearchModalShown: true,
      isUserDropdownOpen: false,
      isNotificationsDropdownOpen: false,
    }),
    [closeSearchModal.toString()]: state => ({
      ...state,
      isSearchModalShown: false,
    }),
    [toggleSearchModal.toString()]: state => ({
      ...state,
      isSearchModalShown: !state.isSearchModalShown,
    }),
    [siteHeaderSearchButtonClicked.toString()]: state => ({
      ...state,
      isUserDropdownOpen: false,
      isNotificationsDropdownOpen: false,
    }),
    [openUserDropdown.toString()]: state => ({
      ...state,
      isUserDropdownOpen: true,
      isNotificationsDropdownOpen: false,
    }),
    [closeUserDropdown.toString()]: state => ({
      ...state,
      isUserDropdownOpen: false,
    }),
    [openNotificationsDropdown.toString()]: state => {
      return {
        ...state,
        isNotificationsDropdownOpen: true,
        isUserDropdownOpen: false,
        isDamzDropdownOpen: false,
      };
    },
    [closeNotificationsDropdown.toString()]: state => ({
      ...state,
      isNotificationsDropdownOpen: false,
    }),
    [toggleFeedbackPage.toString()]: state => ({
      ...state,
      isNotificationsDropdownOpen: false,
    }),
    [toggleSubmitMenu.toString()]: state => {
      const isOpen = !state.isSubmitMenuOpen;
      return {
        ...state,
        isSubmitMenuOpen: isOpen,
      };
    },
    [toggleBurgerMenuRequested.toString()]: (
      state,
      { payload: { isOpenAfter } }: ReturnType<typeof toggleBurgerMenuRequested>
    ) => ({
      ...state,
      isBurgerMenuOpen: isOpenAfter ?? !state.isBurgerMenuOpen,
    }),
    [userLogoutButtonClicked.toString()]: state => ({
      ...state,
      isLoggingOut: true,
    }),
    [userLogoutButtonClicked.toString()]: state => ({
      ...state,
      isLoggingOut: true,
    }),
    // Damz
    [openDamzDropdown.toString()]: state => {
      return {
        ...state,
        isDamzDropdownOpen: true,
        isNotificationsDropdownOpen: false,
        isUserDropdownOpen: false,
      };
    },
    [closeDamzDropdown.toString()]: state => ({
      ...state,
      isDamzDropdownOpen: false,
    }),
  },
  initialState
);

export default {
  [reduxKey as string]: actionHandlers,
};
